import styled from 'styled-components'
import {COMMON, TYPOGRAPHY, SystemTypographyProps} from '../../constants'
import sx, {SxProp} from '../../sx'
import {ComponentProps} from '../../utils/types'
import {ExtendedSystemCommonProps} from './types'

/**
 * The Text component is a utility component that applies typography styles to the text inside.
 *
 * When choosing whether to use margin, consider using a structural layout component like `<Spacer>` instead.
 */
const Text = styled.span<ExtendedSystemCommonProps & SxProp & SystemTypographyProps>`
  ${COMMON}
  ${TYPOGRAPHY}
  ${sx};
`
export type TextProps = ComponentProps<typeof Text>
export default Text
